{
  "title": {
    "documents": "All documents",
    "reports": "All reports"
  },
  "sections": {
    "label": "Sections",
    "documents": "Documents",
    "reports": "Reports"
  },
  "search": "Search",
  "views": {
    "label": "View",
    "table": "Table",
    "grid": "Cards",
    "columns": "Columns"
  },
  "create": {
    "button": "Create",
    "folder": "New folder",
    "upload": "Upload document"
  },
  "columns": {
    "name": "Name",
    "type": "Type",
    "size": "Size",
    "createdAt": "Created",
    "updatedAt": "Modified",
    "createdBy": "Created by",
    "visibility": "Visibility",
    "actions": "Actions"
  },
  "types": {
    "folder": "Folder",
    "pdf": "Pdf",
    "word": "Word",
    "excel": "Excel",
    "powerpoint": "PowerPoint",
    "image": "Image",
    "csv": "CSV",
    "other": "Other"
  },
  "visibility": {
    "private": "Private",
    "selected": "Selected",
    "public": "Public",
    "sharedCount_one": "{{count}} user",
    "sharedCount_other": "{{count}} users"
  },
  "visibilityOption": {
    "private": "Private",
    "selected": "Selected users",
    "public": "Public"
  },
  "visibilityHint": {
    "private": "Only you and the administrators can see it",
    "selected": "You, the administrators and the selected users can see it",
    "public": "Everyone with access to the section can see it"
  },
  "sort": {
    "label": "Sort",
    "name": "Name (A–Z)",
    "-name": "Name (Z–A)",
    "-updatedAt": "Recently modified",
    "updatedAt": "Least recently modified",
    "-createdAt": "Newest",
    "createdAt": "Oldest",
    "-size": "Size: largest first",
    "size": "Size: smallest first",
    "type": "By type",
    "-type": "By type (reversed)",
    "asc": "sorted ascending",
    "desc": "sorted descending",
    "by": "Sort by {{column}}"
  },
  "grid": {
    "author": "Created by: {{name}}",
    "files_one": "{{count}} file",
    "files_other": "{{count}} files",
    "edited": "Modified: {{date}}"
  },
  "actions": {
    "menu": "Actions",
    "open": "Open",
    "download": "Download",
    "rename": "Rename",
    "move": "Move",
    "visibility": "Change visibility",
    "delete": "Delete"
  },
  "inFolder": "{{folder}}",
  "rootFolder": "{{section}} (root folder)",
  "upload": {
    "title": "Upload document",
    "subtitle": "Add a new document to the system",
    "drop": "Upload document",
    "dropActive": "Drop the file here",
    "hint": "{{types}} — up to {{size}}",
    "uploading": "Uploading...",
    "uploadingProgress": "Uploading... {{percent}}%",
    "addMore": "Add more",
    "name": "Document name",
    "folder": "Folder",
    "visibility": "Visibility level",
    "users": "Users",
    "usersPlaceholder": "Select users",
    "usersEmpty": "No users found",
    "usersRequired": "Select at least one user",
    "removeFile": "Remove “{{name}}”",
    "downloadFile": "Download “{{name}}”",
    "saved_one": "Document uploaded",
    "saved_other": "{{count}} documents uploaded",
    "savedText": "Added to “{{folder}}”",
    "rejectedType": "“{{name}}” — this file type is not accepted",
    "rejectedSize": "“{{name}}” — the file is larger than {{size}}",
    "failed": "“{{name}}” was not uploaded",
    "pageDrop": "Drop files here to upload"
  },
  "folder": {
    "createTitle": "New folder",
    "createSubtitle": "A new folder in {{section}}",
    "name": "Folder name",
    "namePlaceholder": "e.g. 2026 reports",
    "created": "Folder created"
  },
  "rename": {
    "title": "Rename",
    "name": "Name",
    "saved": "Renamed"
  },
  "move": {
    "title": "Move",
    "subtitle": "New location for “{{name}}”",
    "target": "Folder",
    "saved": "Moved"
  },
  "visibilityModal": {
    "title": "Change visibility",
    "saved": "Visibility changed"
  },
  "delete": {
    "documentTitle": "Delete the document?",
    "documentText": "“{{name}}” will be deleted.",
    "folderTitle": "Delete the folder?",
    "folderText": "The folder “{{name}}” will be deleted.",
    "folderTextNonEmpty": "The folder “{{name}}” will be deleted together with {{documents}} file(s) and {{folders}} folder(s) inside.",
    "done": "Deleted"
  },
  "access": {
    "title": "Access",
    "count": "{{count}}",
    "author": "Author",
    "view": "View",
    "unknown": "Unknown user"
  },
  "columnsView": {
    "meta": "{{type}} document - {{size}}",
    "download": "Download {{ext}}",
    "noPreview": "No preview for this file type"
  },
  "preview": {
    "download": "Download",
    "frame": "Preview of “{{name}}”"
  },
  "empty": {
    "documents": "No documents yet",
    "reports": "No reports yet",
    "text": "There are no documents yet. Click “Upload document”.",
    "textReadonly": "There are no documents here yet.",
    "folderTitle": "The folder is empty",
    "folderText": "There are no documents in this folder yet.",
    "searchTitle": "Nothing found",
    "searchText": "No results for “{{q}}”.",
    "clear": "Clear"
  },
  "notFound": {
    "title": "Folder not found",
    "text": "The folder was deleted or is not visible to you.",
    "back": "Back to the root folder"
  },
  "error": {
    "load": "Could not load the data",
    "retry": "Try again",
    "generic": "Something went wrong"
  },
  "common": {
    "cancel": "Cancel",
    "save": "Save",
    "close": "Close",
    "breadcrumbs": "Folder path",
    "dash": "-"
  }
}
